import { render, staticRenderFns } from "./ZoneTable.vue?vue&type=template&id=6f2ac312&scoped=true&"
import script from "./ZoneTable.vue?vue&type=script&lang=js&"
export * from "./ZoneTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2ac312",
  null
  
)

export default component.exports